/**
 * Don't use this component as icon, use TagSvgIcon component instead. Example: <TAGSvgIcon icon="Location" size=32 />
 */
const Number1Dark = () => (
	<>
		<circle cx="16" cy="16" r="16" fill="#002855" />
		<path
			d="M11.75 24.1875C11.54 24.1875 11.375 24.0225 11.375 23.8125V22.8975C11.375 22.695 11.5325 22.53 11.7275 22.5225C13.82 22.41 13.82 22.365 13.82 21.12V11.04H11.75C11.54 11.04 11.375 10.875 11.375 10.665V9.825C11.375 9.645 11.5025 9.4875 11.6825 9.4575L12.74 9.2625C14.87 8.88 15.9725 8.1975 17.105 6.54C17.1725 6.435 17.2925 6.375 17.4125 6.375H18.275C18.485 6.375 18.65 6.54 18.65 6.75V21.1275C18.65 22.32 18.65 22.395 20.6525 22.53C20.8475 22.545 21.005 22.71 21.005 22.905V23.82C21.005 24.03 20.84 24.195 20.63 24.195H11.75V24.1875Z"
			fill="white"
		/>
	</>
);

export default Number1Dark;
